/**
 * Student Account
 * Student Account Api - Validation flow
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dmartinez@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The ProfileSetChannels model module.
 * @module model/ProfileSetChannels
 * @version 1.0.0
 */
class ProfileSetChannels {
    /**
     * Constructs a new <code>ProfileSetChannels</code>.
     * a profileset channel
     * @alias module:model/ProfileSetChannels
     */
    constructor() { 
        
        ProfileSetChannels.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ProfileSetChannels</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ProfileSetChannels} obj Optional instance to populate.
     * @return {module:model/ProfileSetChannels} The populated <code>ProfileSetChannels</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ProfileSetChannels();

            if (data.hasOwnProperty('tag')) {
                obj['tag'] = ApiClient.convertToType(data['tag'], 'String');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
        }
        return obj;
    }


}

/**
 * @member {String} tag
 */
ProfileSetChannels.prototype['tag'] = undefined;

/**
 * @member {String} name
 */
ProfileSetChannels.prototype['name'] = undefined;






export default ProfileSetChannels;

